// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","682":"component---src-pages-about-js"}[chunkId] + "-" + {"532":"c1b30e72dd1c97ef80cb","678":"763ecaee04e31a51f702","682":"61cf8e461572b2a2db62"}[chunkId] + ".js";
};